<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="700px"
    :before-close="handleClose"
  >
    <div v-loading="loading" class="news-timeline-wrapper">
      <!-- 时间轴列表：显示新闻列表 -->
      <div v-if="newsList.length > 0" class="news-timeline-list">
        <div 
          v-for="(news, index) in newsList" 
          :key="news.news_id"
          class="news-timeline-item"
        >
          <!-- 左侧时间 -->
          <div class="timeline-time">
            {{ formatTime(news.news_time) }}
          </div>
          
          <!-- 中间节点和连接线 -->
          <div class="timeline-node-wrapper">
            <div class="timeline-node"></div>
            <div v-if="index < newsList.length - 1" class="timeline-line"></div>
          </div>
          
          <!-- 右侧内容 -->
          <div class="timeline-content">
            {{ news.news_description || '暂无描述' }}
          </div>
        </div>
      </div>
      
      <!-- 空状态 -->
      <div v-else-if="!loading" class="empty-state">
        <i class="el-icon-info"></i>
        <p>暂无相关时间轴数据</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getBookKeywordsTimeline } from '@/http/api/news'

export default {
  name: 'KeywordsTimelineDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    bookKeywordsId: {
      type: Number,
      default: null
    },
    keywordName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      newsList: []
    }
  },
  computed: {
    dialogTitle() {
      // 显示关键词名称【时间线】
      if (this.keywordName) {
        return `${this.keywordName}【时间线】`
      }
      return '时间线'
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(newVal) {
      console.log('弹窗 visible 变化:', newVal, 'bookKeywordsId:', this.bookKeywordsId)
      if (newVal && this.bookKeywordsId) {
        this.loadTimeline()
      } else if (!newVal) {
        // 关闭时清空数据
        this.newsList = []
      }
    },
    bookKeywordsId(newVal) {
      console.log('bookKeywordsId 变化:', newVal)
      if (this.visible && newVal) {
        this.loadTimeline()
      }
    }
  },
  methods: {
    // 加载时间轴数据
    async loadTimeline() {
      if (!this.bookKeywordsId) return
      
      this.loading = true
      this.newsList = []
      
      try {
        const params = {
          book_keywords_id: this.bookKeywordsId
        }
        const response = await getBookKeywordsTimeline(params)
        
        console.log('时间轴接口返回:', response)
        
        // 根据接口返回的数据结构，直接使用 result 数组
        let newsList = []
        
        if (Array.isArray(response)) {
          // 直接返回数组
          newsList = response
        } else if (response && Array.isArray(response.result)) {
          // 返回 {result: [...]}
          newsList = response.result
        } else if (response && response.list && Array.isArray(response.list)) {
          // 返回 {list: [...]}
          newsList = response.list
        }
        
        console.log('解析后的新闻列表:', newsList)
        
        // 按时间倒序排列（最新的在前）
        this.newsList = newsList.sort((a, b) => {
          const timeA = a.news_time || 0
          const timeB = b.news_time || 0
          return timeB - timeA
        })
        
        console.log('排序后的新闻列表:', this.newsList)
        
      } catch (error) {
        console.error('加载时间轴数据失败:', error)
        this.$message.error('加载时间轴数据失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    
    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return '未知时间'
      
      // 判断时间戳是秒还是毫秒
      // 如果大于 10000000000（2286年），说明是毫秒
      const date = timestamp > 10000000000 
        ? new Date(timestamp) 
        : new Date(timestamp * 1000)
      
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      
      return `${year}-${month}-${day}`
    },
    
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.news-timeline-wrapper {
  min-height: 200px;
  max-height: 500px;
  overflow-y: auto;
  padding: 10px 0;
}

.news-timeline-list {
  padding: 0 20px;
}

.news-timeline-item {
  display: flex;
  align-items: flex-start;
  position: relative;
  padding-bottom: 30px;
  
  &:last-child {
    padding-bottom: 0;
  }
}

/* 左侧时间 */
.timeline-time {
  flex-shrink: 0;
  width: 140px;
  padding-right: 20px;
  text-align: right;
  color: #909399;
  font-size: 13px;
  line-height: 1.5;
  padding-top: 2px;
}

/* 中间节点和连接线 */
.timeline-node-wrapper {
  flex-shrink: 0;
  width: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.timeline-node {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #409EFF;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #409EFF;
  z-index: 2;
  flex-shrink: 0;
  position: relative;
}

.timeline-line {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: calc(100% + 30px);
  background-color: #E4E7ED;
  z-index: 1;
}

/* 右侧内容 */
.timeline-content {
  flex: 1;
  padding-left: 20px;
  color: #303133;
  font-size: 14px;
  line-height: 1.8;
  word-break: break-word;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
  
  i {
    font-size: 48px;
    margin-bottom: 16px;
    display: block;
    opacity: 0.5;
  }
  
  p {
    font-size: 14px;
    margin: 0;
  }
}

/* 滚动条样式 */
.news-timeline-wrapper::-webkit-scrollbar {
  width: 6px;
}

.news-timeline-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.news-timeline-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.news-timeline-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}
</style>

